// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;

  > svg:nth-child(1),
  > svg:nth-child(2) {
    position: absolute;
    width: 650px;
  }

  > svg:nth-child(1) {
    top: 100px;
    left: -20px;
  }

  > svg:nth-child(2) {
    top: 450px;
    right: calc(100% - 2530px);
    transform: scaleX(1.2) scaleY(1.05);
    z-index: 2;
  }

  @media (max-width: 1920px) {
    > svg:nth-child(2) {
      right: calc(100% - 1800px);
    }
  }

  @media (max-width: 1400px) {
    > svg:nth-child(1) {
      top: 100px;
      left: -60px;
      transform: scale(0.9);
    }

    > svg:nth-child(2) {
      top: 420px;
      right: calc(100% - 1430px);
      transform: scale(0.9);
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;

  .content {
    padding-top: 370px;
  }

  .card-wrapper {
    position: relative;
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-top: 100px;
    gap: 60px;
    color: rgba(255, 255, 255, 0.5);
    height: 100%;

    > div {
      height: 500px;
    }

    header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: 30px;
      padding-top: 30px;

      h3 {
        opacity: 1;
        color: #fff;
        padding-left: 30px;
      }

      img {
        border-radius: 100%;
        z-index: -1;
      }

      @media (max-width: 992px) {
        img {
          width: 100px;
          border-radius: 100%;
          z-index: -1;
        }

        margin-bottom: 10px;
      }
    }

    .card-inside {
      padding: 32px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      margin-top: -20px;
      z-index: 2;
      height: 100%;

      position: relative;

      > div {
        margin-bottom: 32px;
        height: 240px;

        > p:nth-child(1) {
          margin-bottom: 20px;
        }
      }

      footer {
        display: flex;
        justify-content: space-between;

        h3 {
          color: #fff;
          font-size: 14px;
          margin-bottom: 2px;
        }

        span {
          font-size: 14px;
        }

        a {
          display: flex;
          justify-content: center;
          align-items: center;
          background: transparent;
          border: none;
          border-radius: 100%;
          border: 1px solid #222;
          width: 40px;
          height: 40px;
          transition: 0.3s ease-in-out;

          svg {
            transition: 0.3s ease-in-out;
          }

          &:hover {
            background: #222;
            cursor: pointer;

            svg {
              transform: translateX(2px);
            }

            &:active {
              transform: scale(0.98);

              svg {
                transform: scale(0.97);
              }
            }
          }
        }
      }

      @media (max-width: 1200px) {
        > div {
          p {
            font-size: 14px;
          }
        }
      }

      @media (max-width: 992px) {
        > div {
          p {
            font-size: 16px;
          }
        }
      }
    }

    > div:nth-child(1) {
      z-index: 2;

      .card-inside {
        footer {
          span {
            color: #02fde8;
          }
        }
      }
    }
    > div:nth-child(2) {
      z-index: 2;

      .card-inside {
        footer {
          span {
            color: #ffa5f6;
          }
        }
      }
    }
    > div:nth-child(3) {
      z-index: 2;

      .card-inside {
        footer {
          span {
            color: #ffa5f6;
          }
        }
      }
    }
  }

  @media (max-width: 992px) {
    .mobile-title {
      margin-top: 120px;
      margin-bottom: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      h1 {
        color: #565656;
        font-family: 'SF Pro Display';
        font-size: 24px;
        font-style: normal;
        font-weight: 700;

        strong {
          color: #fff;
        }
      }
    }

    .card-wrapper {
      margin-top: unset;
      flex-direction: column;
      gap: 30px;

      > img {
        position: absolute;
        right: -260px;
        top: -110px;
        /* width: 200%; */

        /* &:nth-child(2) {
          top: unset;
          left: -16px;
          bottom: -25px;
          z-index: 1;
        } */
      }

      footer {
        span {
          color: #ffa5f6;
        }
      }

      > div:nth-child(5) {
        z-index: 2;
      }
    }
  }
`;
